import { Result } from 'antd';

import { PREFIX } from '@app/constants/appPrefix';

import '@app/pages/YooKassa/components/YooKassaSuccessPayment/styles/YooKassaSuccessPayment.desktop.scss';

export const YooKassaSuccessPayment = () => {
  return (
    <div className={`${PREFIX}yoo-kassa-success-payment`}>
      <Result
        status="success"
        title="Спасибо!"
        subTitle="Ваш платёж через ЮKassa обработан. Визит оплачен."
      />
    </div>
  );
};
